function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 5",
  cx: 70,
  cy: 10,
  rx: 70,
  ry: 10,
  fill: "rgba(129,129,129,0.17)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 111",
  d: "M153.6 16.343c14.136 0 25.6 1.637 25.6 3.657s-11.464 3.657-25.6 3.657S128 22.02 128 20s11.461-3.657 25.6-3.657z",
  fill: "rgba(129,129,129,0.17)"
});

function SvgTorShadow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179.197,
    height: 23.657
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNzkuMTk3IiBoZWlnaHQ9IjIzLjY1NyIgdmlld0JveD0iMCAwIDE3OS4xOTcgMjMuNjU3Ij4KICA8ZWxsaXBzZSBpZD0iRWxsaXBzZV81IiBkYXRhLW5hbWU9IkVsbGlwc2UgNSIgY3g9IjcwIiBjeT0iMTAiIHJ4PSI3MCIgcnk9IjEwIiBmaWxsPSJyZ2JhKDEyOSwxMjksMTI5LDAuMTcpIi8+CiAgPHBhdGggaWQ9IlBhdGhfMTExIiBkYXRhLW5hbWU9IlBhdGggMTExIiBkPSJNMjUuNiwwQzM5LjczNiwwLDUxLjIsMS42MzcsNTEuMiwzLjY1N1MzOS43MzYsNy4zMTQsMjUuNiw3LjMxNCwwLDUuNjc3LDAsMy42NTcsMTEuNDYxLDAsMjUuNiwwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTI4IDE2LjM0MykiIGZpbGw9InJnYmEoMTI5LDEyOSwxMjksMC4xNykiLz4KPC9zdmc+Cg==";
export { SvgTorShadow as ReactComponent };